// /* global dataLayer */
import React, { useEffect } from 'react';
import ReactGA from 'react-ga4';
import {GoogleTagsKey} from "../../config/client-config";
const Footer = () => {
  // const date = new Date()
  // const currentYear = date.getFullYear()

    useEffect(() => {
        ReactGA.initialize(GoogleTagsKey);
        ReactGA.send({
            page: window.location.pathname
        });

    // If you want to track events, uncomment the following lines
    // ReactGA.event({
        //     category: "category",
        //     action: "action",
        //     label: "label", // optional
        //     value: 99, // optional, must be a number
        //     nonInteraction: true, // optional, true/false
        //     transport: "xhr", // optional, beacon/xhr/image
        // });

    }, []);
  return (
      <footer className='footer-bottom-container'>
                  <div className='footer-block'>
                      <div className='footer-developed-by'>
                          {/* Copyright {currentYear} &copy; All Rights Reserved -  */}
                          dev:{' '}
                          <a
                              target='_blank'
                              className='developed-by-link'
                              href='mailto:info@spacetime.community'
                              rel='noreferrer'
                          >
                              paradoxos
                          </a>
                          <br/>
                          {/*<img src='/demo_logo.gif' width='50' height='50' alt='logo' />*/}
                      </div>
                  </div>
      </footer>
  )
}

export default Footer
